export const SET_AWARD = "SET_AWARD";

export const setAward = (award) => {
  return {
    type: SET_AWARD,
    payload: award,
  };
};
